import { timezones } from "data/timezones";
import dayjs from "dayjs";

export const currentTimeZoneTime = (timeZone?: string) => {
  let parsed: string | string[] | undefined = timeZone;
  try {
    if (timeZone) parsed = JSON.parse(timeZone);
  } catch {
    parsed = timeZone;
  }
  const resolvedTimeZone: string = Array.isArray(parsed)
    ? parsed[0]
    : parsed ?? "";
  const tz = timezones.find((t) => t.utc.includes(resolvedTimeZone || ""));
  const tzName = tz?.utc?.[0];
  let time = dayjs().format("hh:mm A");
  if (tzName) {
    time = dayjs().tz(tzName).format("hh:mm A");
  }
  return { time, zone: tz?.abbr };
};
